import React from 'react';
import {
  SectionStyled,
  StyledCard,
  StyledContainer,
  StyledDiv,
  StyledSpan,
} from './HowWeDrivePerformance.styled';

const HowWeDrivePerformance = ({ data }) => {
  return (
    <SectionStyled headerStyle={data?.headerStyle}>
      <StyledContainer className='container'>
        {data.info && (
          <div className='info'>
            <h1 className='info_text_style'>{data.info}</h1>
          </div>
        )}
        <StyledSpan contentStyle={data?.headerStyle}>
          <h3 className='headerStyle'>
            {data.heading1}
            <span className='title_or'>{data.heading2}</span>
          </h3>
        </StyledSpan>
        {data.content && (
          <StyledDiv className='title_mid'>{data.content}</StyledDiv>
        )}
        <StyledDiv
          className='card_wrapper'
          globalStyle={data?.globalCardsStyle}
        >
          {data?.cardData?.map(
            (
              { background, icon, title, details, color, cardStyles },
              index
            ) => {
              return (
                <StyledCard
                  style={{
                    background,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    color,
                  }}
                  cardsPerRow={data.cardData.length}
                  key={index}
                  itemStyle={cardStyles}
                >
                  <StyledDiv itemStyle={cardStyles} className='card_container'>
                    {icon && <img src={icon} alt='icon' loading='lazy' />}
                    {title && (
                      <StyledDiv className='title_s'>{title}</StyledDiv>
                    )}
                    {details && (
                      <StyledDiv className='title_ss'>{details}</StyledDiv>
                    )}
                  </StyledDiv>
                </StyledCard>
              );
            }
          )}
        </StyledDiv>
      </StyledContainer>
    </SectionStyled>
  );
};

export default HowWeDrivePerformance;
